import {Col, Container, Row, Form} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "../../context/action";

export default function SwiftTransactionCompleteModal(props) {

    const {setShowComplete, setShow, selectedRows} = props;
    const {isDesktop, isMobile} = useWindowDimensions();
    const {handleSwiftTransactionComplete} = useContext(ActionPanelContext);
    const [submitting, setSubmitting] = useState(false);
    const [completeComment, setCompleteComment] = useState('');
    const [errors, setErrors] = useState({});

    const clearErrors = (field) => {
        if (!!errors[field]) {
            setErrors({...errors, [field]: null});
        }
    };

    const validateReference = () => {
        const value = (completeComment || "").trim();
        if (!value) {
            setErrors({...errors, reference: "Reference is required."});
            return false;
        }
        clearErrors("reference");
        return true;
    };

    return (<div className='modal-container'>
        <Container fluid className={props.isActionColBtn?"d-none":"my-3 my-md-0"}>
            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>Are you sure you want to complete this Swift Transaction?</h4>
                    <br/>
                </Col>
            </Row>
            <Row className={"pr-4"}>
                <Col md={6} xs={12}>
                    <Form.Group controlId="formGridReference">
                        <Form.Label>TD Reference *</Form.Label>
                        <Form.Control
                            type="text"
                            value={completeComment}
                            onChange={(e) => {
                                setCompleteComment(e.target.value);
                                clearErrors("reference");
                            }}
                            placeholder="Enter Payment Ref Num"
                            disabled={submitting}
                            isInvalid={!!errors.reference}
                        />
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.reference}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <br/>
            <Row className={"justify-content-end pr-4"}>
                <Col md={6} xs={12}>
                    <button disabled={submitting} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowComplete(false);
                    }}>Cancel
                    </button>
                </Col>
                <Col md={6} xs={12}>
                    <button disabled={submitting} className={'btn btn-block td-btn-primary-light'} href="#" onClick={() => {
                        if (submitting) return;
                        if (!validateReference()) return;

                        setSubmitting(true);

                        const onSuccess = () => {
                            setSubmitting(false);
                            setShow(false);
                            setShowComplete(false);
                        };

                        const onError = () => {
                            setSubmitting(false);
                            setShow(false);
                            setShowComplete(false);
                        };
                        handleSwiftTransactionComplete(selectedRows, onSuccess, onError, (completeComment || "").trim());
                    }}>Complete
                    </button>
                </Col>
            </Row>
        </Container>
    </div>)
}
SwiftTransactionCompleteModal.defaultProps = {
    confirmCancelBtnClassName: "btn btn-block td-btn-red"
}
